module.exports = __webpack_public_path__ + "static/media/monopoly.97cc8aa1.svg";